import React, { memo } from 'react';
import { EndDestinyPin, ErrorBoundary, } from 'components';
import { Marker, InfoWindow } from '@react-google-maps/api'
import { localizedStrings } from 'constants/localizedStrings';
export default memo(({
    location,
    showVehicleIcon = false,
    showVehicleName,
    clusterer,
    ...pinOptions
}) => {
    return (
        <ErrorBoundary>
            <Marker
                title={location?.name}
                clickable={false}
                icon={showVehicleIcon && {
                    url: ""
                }}
                draggable={false}
                clusterer={clusterer}
                position={{ lat: location?.lat, lng: location?.lng }}
            >
                {
                    showVehicleIcon &&
                    <InfoWindow>
                        <EndDestinyPin
                            showVehicleName={showVehicleName}
                            name={localizedStrings.logisticsServices.arrivePlace}
                            cursor={"pointer"}
                            backgroundColor={"transparent"}
                            textOptions={true}
                            position={"relative"}
                            {...pinOptions}
                        />
                    </InfoWindow>
                }
            </Marker>
        </ErrorBoundary>
    )
})